import { AlertColor, Box, Divider, Grid, TextField, Typography } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import InputMask from "react-input-mask";
import { useProfile } from "../../../../context/ProfileProvider/useProfile";
import { GetUser } from "../../../../services/UserServices";

interface IDataRenderPersonalInformation {
    phone: string;
    username: string;
    setUsername: (set: string) => void;
    setPhone: (set: string) => void;
    setPopupOk: (set: boolean) => void;
    setAlertColor: (set: AlertColor) => void;
    setMessage: (set: string) => void;
}

export const DataRenderPersonalInformation: React.FC<IDataRenderPersonalInformation> = ({
    phone,
    setPhone,
    setUsername,
    username
}) => {

    const { t } = useTranslation();
    const profile = useProfile();

    useEffect(() => {
        GetUser(profile?.id!)
        .then((data) => {
            setPhone(data?.phone!);
            setUsername(data?.name!);
        })
    }, [])

    return (
        <Grid item xs={12}>
            <Box
                marginTop="18px"
            >
                <Typography
                    fontWeight="600"
                    fontSize="14px"
                    color="#2D2D2D"
                >
                    {t("MyData.PersonaInformation")}
                </Typography>
            </Box>
            <Box
                display="flex"
                justifyContent="space-between"
            >
                <Box
                    marginTop="20px"
                    width="33%"
                >
                    <TextField
                        required
                        variant="standard"
                        placeholder={t("MyData.Name")}
                        fullWidth
                        value={username}
                        onChange={e => {
                            setUsername(e.currentTarget.value);
                            profile.setHavePersonalDataModification(true);
                        }}
                        inputProps={{
                            maxLength: 128
                        }}
                    />
                </Box>
                <Box
                    marginTop="20px"
                    width="33%"
                >
                    <TextField
                        variant="standard"
                        fullWidth
                        placeholder={t("MyData.Login")}
                        value={profile.login}
                        disabled={true}
                    />
                </Box>
                <Box
                    marginTop="20px"
                    width="33%"
                >
                    <InputMask
                        autoComplete="new-password"
                        mask="+55 (99) 99999-9999"
                        value={phone}
                        disabled={false}
                        maskChar=" "
                        onChange={(e: any) => {
                            setPhone(e.target.value);
                            profile.setHavePersonalDataModification(true);
                        }}
                    >
                        {() => <TextField placeholder={t("MyData.PhoneNumber")} variant="standard" fullWidth value={phone} />}
                    </InputMask>
                </Box>
            </Box>
            <Divider
                sx={{
                    marginTop: "20px",
                    opacity: .2,
                    borderColor: "#22638D",
                    
                }}
            />
        </Grid>
    )
}